import Button from '@anm/components/buttons/Button/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { media } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

export type UserEmailAlertProps = {
  isPending?: boolean;
  onSend: () => void;
};

const adaptiveAlertStyles = media.desktop_small`
  flex-grow: 1;
`;

const Text = styled.div`
  flex-grow: 2;
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 10px;
  margin-top: 30px;
  line-height: 28px;
  border: 1px solid #fcbd26;
  box-sizing: border-box;
  border-radius: 5px;
  background: #fff4db;
  ${Text}, ${Button} {
    margin: 5px 10px;
    flex-basis: 270px;
    ${adaptiveAlertStyles};
  }
`;

const UserEmailAlert: FC<UserEmailAlertProps> = ({ isPending, onSend }) => (
  <Wrapper>
    <Text>Please confirm your email to ensure you can log in to Wave.video, even if you forget your password.</Text>

    <ButtonLoader isPending={isPending} variant="light-blue" size="large_long_static" onClick={onSend}>
      Resend Confirmation Email
    </ButtonLoader>
  </Wrapper>
);

export default UserEmailAlert;
